import type { ImageView } from '@vizit/api';
import { type Key, MenuItem, MenuSection, Text, TextWeight } from '@vizit/atoms';
import { Trash01Icon } from '@vizit/icons';
import { Asset } from '@vizit/molecules';
import { ContextMenuMode } from '@vizit/molecules';
import { colors } from '@vizit/theme';
import { getHeroImageScore } from '@vizit/utils';

/**
 * Individual collection asset component with context menu
 */
interface CollectionAssetProps {
  image: ImageView;
  onAssetClick?: (id: string) => void;
  onRemoveImageDialogOpen?: (id: string) => void;
}

function CollectionAsset(props: CollectionAssetProps) {
  const { image, onAssetClick, onRemoveImageDialogOpen } = props;
  const handleOnAction = (key: Key) => {
    if (key === 'remove_asset') {
      onRemoveImageDialogOpen?.(image.id);
    }
  };

  const score = getHeroImageScore({
    imageType: image.image_type,
    heroScore: image.hero_score,
    vizitScore: image.vizit_score,
  });

  return (
    <Asset
      onPress={() => {
        onAssetClick?.(image.id);
      }}
      key={image.id}
      score={score}
      isUnscored={score === null}
      unscoredLabel="Unscored"
    >
      <Asset.Image name={image.name} src={image.url_360 ?? image.url} fallbackSrc={image.url} />
      <Asset.ContextMenu onAction={handleOnAction} mode={ContextMenuMode.Dark}>
        <MenuSection>
          <MenuItem id="remove_asset">
            <Trash01Icon size={16} color={colors['gray-utility'][400]} />
            <Text weight={TextWeight.Medium} slot="label">
              Delete image
            </Text>
          </MenuItem>
        </MenuSection>
      </Asset.ContextMenu>
    </Asset>
  );
}

export { CollectionAsset };
